import type { MenuItem } from "@v1/components/designSystem/menu/Menu";

import * as React from "react";

import { Menu } from "@v1/components/designSystem/menu/Menu";
import { ChevronDown } from "lucide-react";

type ChevronMenuIndicatorProps = {
  items: MenuItem[];
  menuWidth?: number;
  align?: "end" | "center" | "start";
  isDisabled?: boolean;
  alignOffset?: number;
  sideOffset?: number;
};

const ChevronMenuIndicator = ({
  items,
  menuWidth,
  align,
  isDisabled = false,
  alignOffset = 0,
  sideOffset = 0,
}: ChevronMenuIndicatorProps) => (
  <Menu
    items={items}
    menuType="normal"
    customWidth={menuWidth}
    align={align}
    isDisabled={isDisabled}
    sideOffset={sideOffset}
    alignOffset={alignOffset}
    trigger={
      <div className="flex h-4 w-4 items-center justify-center rounded-sm">
        <ChevronDown className="text-muted" size={12} />
      </div>
    }
  />
);

export default ChevronMenuIndicator;
